(() => {
  const node = document.getElementById('mobai-mail-source-context');
  if (!node) return;
  let context;
  try { context = JSON.parse(node.textContent); } catch { return; }
  if (context.recipient !== 'hellomobai@163.com') return;
  const isStoreEmail = link => {
    const href = link.getAttribute('href') || '';
    const recipient = href.replace(/^mailto:/i, '').split('?')[0].toLowerCase();
    return /^mailto:/i.test(href) && recipient === context.recipient;
  };
  const enhance = root => {
    const links = root.matches?.('a[href]') ? [root] : root.querySelectorAll?.('a[href]') || [];
    for (const link of links) if (isStoreEmail(link)) link.setAttribute('href', context.href);
  };
  enhance(document);
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (link && isStoreEmail(link)) link.setAttribute('href', context.href);
  }, true);
  new MutationObserver(records => {
    for (const record of records) for (const added of record.addedNodes) {
      if (added.nodeType === 1) enhance(added);
    }
  }).observe(document.body, {childList: true, subtree: true});
})();
